import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, unref as _unref, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-lil" }
const _hoisted_2 = { class: "search-view-input-set" }
const _hoisted_3 = { class: "h-30" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex-1" }
const _hoisted_7 = { class: "text-xl font-semibold text-base" }
const _hoisted_8 = { class: "text-grey-600" }

import { API_CONFIG, BACKEND_URL } from '@/services/apiConfig';
    import { onMounted, ref } from 'vue';
    import { useRoute } from 'vue-router';
    import debounce from "lodash.debounce";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'FaqListView',
  setup(__props) {

    const route = useRoute();
    const itemsList = ref([] as any[]);
    const selectedItem = ref(null as any);
    const query = ref("");

    onMounted(() => {
        const data: any = route.meta.startup_infos;
        itemsList.value = data;
    });

    function doSelectItem(item: any) {
        if (selectedItem.value?.id == item.id) {
            selectedItem.value = null;
        } else {
            selectedItem.value = item;
        }
    }

    const search = debounce(async () => {
        const params = new URLSearchParams({
            q: query.value
        });
        const response = await fetch(`${API_CONFIG.baseURL}/faq?${params.toString()}`, {
            method: 'GET',
            headers: API_CONFIG.headers
        });
        const responseData = await response.json();
        itemsList.value = responseData;
    }, 300);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "page-space" }, null, -1)),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "search-view-input",
          placeholder: "Faire une recherche...",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(search) && _unref(search)(...args)))
        }, null, 544), [
          [_vModelText, query.value]
        ]),
        _cache[2] || (_cache[2] = _createStaticVNode("<button class=\"btn-ultra white tips\"><div class=\"btn-show\"><img src=\"/public/icons/icon-go.svg\" class=\"btn-icon\" alt=\"\"></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button>", 1))
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsList.value, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: 'item_' + item.id
          }, [
            _createElementVNode("div", {
              onClick: ($event: any) => (doSelectItem(item)),
              class: "flex items-center gap-4 p-4 border border-grey-200 rounded-lg cursor-pointer hover:bg-grey-50 transition-all"
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: item.fichier_photo_url,
                  style: {"height":"65px"}
                }, null, 8, _hoisted_5)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h3", _hoisted_7, _toDisplayString(item.libelle), 1),
                _createElementVNode("p", _hoisted_8, _toDisplayString(item.categorie_aide?.libelle), 1),
                _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-primary-color font-medium mt-1" }, "FAQ", -1))
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "h-5 w-5 text-grey-400",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M9 5l7 7-7 7"
                  })
                ])
              ], -1))
            ], 8, _hoisted_4),
            _withDirectives(_createElementVNode("div", null, _toDisplayString(item.contenu_aide), 513), [
              [_vShow, selectedItem.value?.id == item.id]
            ])
          ], 64))
        }), 128))
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "clear-both h-40" }, null, -1))
    ])
  ], 64))
}
}

})